<div id="document-viewer" #documentviewer>
  @if (activePackageDocument) {
    @if (activePackageDocument.isSmartDoc) {
      <app-smart-document-viewer
        [packageDoc]="activePackageDocument"
        [topOffset]="topOffset"
        [bottomOffset]="bottomOffset"
        class="document-rendered-view"
      ></app-smart-document-viewer>
    } @else {
      <img
        class="document-rendered-view"
        data-private
        [src]="
          'data:image/png;base64,' +
          activePackageDocument.packageDocumentImageString
        "
        [ngStyle]="{
          'margin-top': topOffset ? topOffset.toString() + 'px' : '0px',
          'margin-bottom': bottomOffset ? bottomOffset.toString() + 'px' : '0px'
        }"
        alt=""
        />
      }
    }
  </div>

  <ng-content></ng-content>
